// mutations.js

const mutations = {
    setData(state, data) {
      // Update the state with the fetched data
      state.data = data;
    },
  };
  
  export default mutations;
  